
































































import DictMixin from '@/mixins/dict-mixin';
import DimensionServices from '@/services/dimension';
import { SubjectItemDto } from '@/services/subject';
import { mixins } from 'vue-class-component';
import { Component, PropSync } from 'vue-property-decorator';

@Component
export default class SubjectForm2 extends mixins(DictMixin) {
  @PropSync('subFieldList') syncSubFieldList!: SubjectItemDto[];

  dimSrv = new DimensionServices();

  dimList: any = [];
  created() {
    this.getDimList();
  }

  async getDimList() {
    this.dimList = await this.dimSrv.getTree({ status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  onChangeDim(e: string[], index: number) {
    let [dimCode, dimFieldCode] = e;
    this.syncSubFieldList[index].refDimCode = dimCode;
    this.syncSubFieldList[index].refDimFieldCode = dimFieldCode;
    this.$forceUpdate();
  }

  /**
   * 主题表属性列表的字段类别发生变化时执行关联维度的初始化处理
   */
  changeFieldCategory(e: any, index: number) {
    switch (e) {
      case '0': // 时间期
        this.syncSubFieldList[index].refDimCode = 'DICT_DATA_DATE_TYPE';
        this.syncSubFieldList[index].refDimFieldCode = '';
        break;
      case '1': // 维度值
        this.syncSubFieldList[index].refDimCode = '';
        this.syncSubFieldList[index].refDimFieldCode = '';
        break;
      case '2': // 度量值
        this.syncSubFieldList[index].refDimCode = 'DICT_IND_DIM';
        this.syncSubFieldList[index].refDimFieldCode = '';
        break;
      default:
        // 属性值
        this.syncSubFieldList[index].refDimCode = '';
        this.syncSubFieldList[index].refDimFieldCode = '';
    }
  }

  addList() {
    this.syncSubFieldList.push({
      status: 0,
      refDimCode: '',
      refDimFieldCode: '',
      fieldSort: 1
    });
  }

  removeList(index: number) {
    this.syncSubFieldList.splice(index, 1);
  }

  dimValue: any[] = [];
}
